module.exports = __webpack_public_path__ + "svg/klarna.36066efe7f25da88b3e119b52168a40a.svg";